import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Pagination } from 'antd';
import dayjs from 'dayjs';
import { CDN1 } from '@/helpers/api';

export default function CardNews({ news, configInfo }) {
  // sort oldest to newest
  const sortedNews = [...news].sort(
    (a, b) =>
      new Date(b.dt_last_deploy).getTime() -
      new Date(a.dt_last_deploy).getTime()
  );

  const itemsPerPage = 6;

  const [currentPage, setCurrentPage] = useState(1);

  const renderNews = () => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedNews.slice(indexOfFirstItem, indexOfLastItem);

    return currentItems.map((item) => (
      <Link
        key={item.press_id}
        href={`/parking/pressroom/${item.press_friendly_url}`}
        passHref
      >
        <div className="border border-primary/50 p-6 flex flex-col min-h-[32rem] overflow-hidden">
          <div className="relative w-full max-w-[20rem] h-[20rem] mx-auto">
            <Image
              src={`${CDN1}/upload/${
                configInfo.isSandBoxEnvironment
                  ? 1
                  : configInfo.isProductionEnvironment
                  ? 2
                  : 0
              }/${item.load_extra_data?.event_image}`}
              layout="fill"
              objectFit="contain"
              alt="Event Background"
            />
          </div>

          <div className="min-h-[8rem]">
            <h3 className="text-xl md:text-2xl font-bold mt-4 md:min-h-[4rem]">
              {item.landing_seo_title}
            </h3>
            <p className="text-base md:text-lg mt-2 md:min-h-[5rem]">
              {item.landing_display_header}
            </p>
          </div>
          <p className="text-right mt-6 text-sm text-gray-500">
            {dayjs(item.dt_last_deploy).format('MMMM D, YYYY')}
          </p>
        </div>
      </Link>
    ));
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  return (
    <div className="max-w-7xl mx-auto my-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {renderNews()}
      </div>

      <div className="flex justify-center mt-6">
        <Pagination
          current={currentPage}
          total={sortedNews.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
}
